import React from 'react';
import { usePromoBoxEffect } from './promo-box.effect';
import { PromoBoxProps } from './promo-box.props';

export const PromoBoxOrganism = (props: PromoBoxProps) => {
  const { addPromoProductToCart } = usePromoBoxEffect();
  const dropsProductVariantId = 216;

  return (
    <div
      data-cy="promo-box"
      className="bg-waldo-light-blue p-5 mx-auto lg:mx-0 rounded-lg mb-3 mt-5 lg:mt-3"
    >
      <h3 className="mb-4 text-base text-center font-waldo-sans font-semibold md:text-2xl">
        {props.title}
      </h3>
      <div className="flex items-center py-2.5 pl-5 pr-0 bg-waldo-lighter-blue rounded-lg">
        <img className="w-28 h-auto" src={props.imageUrl} alt="Promo image" />
        <div>
          <p className="promo-subtitle waldo-sans font-medium">
            {props.subtitle}
          </p>
          <p className="promo-description waldo-sans">{props.description}</p>
        </div>
      </div>
      <div className="flex justify-center mt-4 mb-2">
        <button
          onClick={() => addPromoProductToCart(dropsProductVariantId, 1)}
          className="button btn-third-cta waldo-sans text-uppercase font-waldo-header font-medium text-base"
        >
          {props.buttonText}
        </button>
      </div>
    </div>
  );
};
